import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../../services/api";
import { endpoints } from "../../services/endpoints";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!identifier.trim()) {
      setError(
        t("forgotPassword.errors.required", {
          defaultValue: "Debes introducir un email o un DNI",
        })
      );
      return;
    }

    setLoading(true);

    try {
      await api.post(endpoints.auth.forgotPassword, {
        identifier, // email o dni
      });

      setSubmitted(true);
    } catch (err) {
      console.error("Error en forgot password:", err);

      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="bg-white p-6 rounded shadow w-full max-w-md space-y-4 text-center">
          <h1 className="text-xl font-semibold">
            {t("forgotPassword.success.title", {
              defaultValue: "Correo enviado",
            })}
          </h1>

          <p className="text-sm text-gray-600">
            {t("forgotPassword.success.message", {
              defaultValue:
                "Si el usuario existe, te hemos enviado un correo con instrucciones para restablecer tu contraseña.",
            })}
          </p>

          <button
            onClick={() => navigate("/login")}
            className="w-full bg-[#01839C] text-white py-2 rounded hover:bg-[#016b7c]"
          >
            {t("common.actions.backToLogin", {
              defaultValue: "Volver al login",
            })}
          </button>
        </div>
      </div>
    );
  }

 return (
    <div className="min-h-screen flex flex-col relative">

      <div className="absolute left-0 w-full h-full bg-black opacity-60 z-0">
        <img
          src="/img/backend.webp"
          alt={t("forgotPassword.backgroundAlt", {
            defaultValue: "Background",
          })}
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="min-h-screen flex items-center justify-center px-4 relative z-10">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded shadow w-full max-w-md space-y-4"
        >
          <h1 className="text-xl font-semibold text-center">
            {t("forgotPassword.title", {
              defaultValue: "Recuperar contraseña",
            })}
          </h1>

          <p className="text-sm text-gray-600 text-center">
            {t("forgotPassword.subtitle", {
              defaultValue:
                "Introduce tu correo o DNI y te enviaremos instrucciones.",
            })}
          </p>

          <input
            type="text"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder={t("forgotPassword.fields.identifier", {
              defaultValue: "Email o DNI",
            })}
            className="w-full border px-3 py-2 rounded"
            disabled={loading}
          />

          {error && (
            <p className="text-red-600 text-sm text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#01839C] text-white py-2 rounded hover:bg-[#016b7c] disabled:opacity-70"
          >
            {loading
              ? t("forgotPassword.actions.sending", {
                  defaultValue: "Enviando…",
                })
              : t("forgotPassword.actions.submit", {
                  defaultValue: "Enviar",
                })}
          </button>

          <button
            type="button"
            onClick={() => navigate("/login")}
            className="w-full text-sm text-gray-600 hover:underline"
          >
            {t("common.actions.backToLogin", {
              defaultValue: "Volver al login",
            })}
          </button>
        </form>
      </div>
    </div>
  );
}
